import { Component, OnDestroy } from '@angular/core';

import { CostLayerEditHelperService } from '../../services/cost-layer-edit-helper.service';

@Component({
  selector: 'lum-cost-layer-edit',
  templateUrl: './cost-layer-edit.component.html',
  styleUrls: ['./cost-layer-edit.component.scss'],
})
export class CostLayerEditComponent implements OnDestroy {
  constructor(public editHelper :CostLayerEditHelperService) {}

  ngOnDestroy() {
    this.editHelper.revertEdits(); // reset when leaving the edit form
  }
}
